@if (startedPayments?.length) {
  <div class="started-payments">
    <h3><mat-icon>warning</mat-icon><span>Viktigt!</span><mat-icon>warning</mat-icon></h3>
    <p>Startade betalningar har initierats för ordern, men de kan inte med säkerhet fastställas som betalda.</p>
    <h4>Startade betalningar</h4>
    <ul>
      @for (payment of startedPayments; track payment) {
        <li>
          <div class="payment-info">
            <span>Betalningsmetod: {{payment.paymentMethod?.label ||
              'okänt'}}
            </span>
            <span>Betalning startad: {{formatDate(payment.createdDate) || 'okänt'}}
              {{formatTime(payment.createdDate) || 'okänt'}}
            </span>
            <span>Betalnings-ID: {{payment.paymentId}}</span>
            <span>Belopp: {{payment.amount}} kr</span>
          </div>
        </li>
      }
    </ul>
    <p class="warning-text"><strong>Det går inte att påbörja nya betalningar på denna order innan de startade betalningarna har
    hanterats och blivit synkroniserade till kassasystemet.</strong></p>
  </div>
}